import React, { useState, useEffect } from "react";
import Typography from "@visa/vds/typography";
import Link from "@visa/vds/link";
import MCSReadonlyField from "../../../../components/MCSReadonlyField";
import OrderStatus from "../../../../components/order/OrderStatus";
import { DateHelper } from "../../../../_helpers/DateHelper";
import { UserRole } from "../../../../_constants/UserRole";
import { TERMS_OF_USE } from "../../../../_constants/PageRoutes";
import TouHistoryDialog from "../../../TermsOfUse/Components/TermsOfUseHistoryDialog"
import { AuthContext } from "context/AuthContext";
import { touService } from "services/tou.service";

const OrderInformation = (props) => {
    const order = props.order;
    const [isDisplay, setIsDisplay] = useState(false)
    const [touObj, setTouObj] = useState(null);
    const [isExternalOrder, setIsExternalOrder] = useState(order.createdBy);

    const regionDictUrl = {
        1: 'us',
        2: 'ca',
        3: 'ce',
        4: 'ap',
        5: 'la',
        6: 'eu'
    }

    const getTouRecord = async () => {
        const tou = await touService.GetTou(order.touId);
        setTouObj(tou);
    }
    const openTou = async (user) => {
        if (user.entitleId == UserRole.UserExternal_Entitlement) {
            window.open(TERMS_OF_USE + `/v${touObj.version}/${regionDictUrl[touObj.regionCode]}`, "_blank");
        } else {
            setIsDisplay(true);
        }
    }
    const readFullName = () => {
        const user = props.order.createdByUser;
        if(user != null) {
            setIsExternalOrder(user.fullName)
        }
    }
    useEffect(() => {
        getTouRecord();
        readFullName();
    }, [])

    return (
        <>
            <Typography tag="h2">Order Information</Typography>
            <MCSReadonlyField label="Order ID" text={order.id} />
            <MCSReadonlyField
                label="Created By"
                text={isExternalOrder}
            />
            <MCSReadonlyField
                label="Created On"
                text={DateHelper.ToLocaleDateString(order.createdOn)}
            />
            <MCSReadonlyField label="Status" text={<OrderStatus order={order} />} />
            {touObj &&
                <AuthContext.Consumer>
                    {(currentUser) => (
                        <>
                            <Typography className="vss-field-label">
                                <Link inline onClick={() => { openTou(currentUser.user) }}>TOU {touObj.regionName} v{touObj.version}</Link>
                            </Typography>
                        </>
                    )}
                </AuthContext.Consumer>
            }
            <TouHistoryDialog isDisplay={isDisplay} setIsDisplay={setIsDisplay} />
        </>
    );
};

export default OrderInformation;
